import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";
import MethodologyIntro from "@/components/methodology/MethodologyIntro";
import MethodologyBackground from "@/components/methodology/MethodologyBackground";
import MethodologyConcept from "@/components/methodology/MethodologyConcept";
import MethodologyArchitecture from "@/components/methodology/MethodologyArchitecture";
import MethodologyScoring from "@/components/methodology/MethodologyScoring";
import MethodologyExclusions from "@/components/methodology/MethodologyExclusions";
import MethodologyClosing from "@/components/methodology/MethodologyClosing";

const BurnoutMethodology: React.FC = () => {
  return (
    <>
      <SEOHead
        title="Burnout Quiz Methodology: Design, Scoring & Limitations | Ieshia Danielle"
        description="Technical methodology for the Where Is Your Burnout Coming From? six-domain burnout source inventory. Documents the conceptual model, item architecture, scoring rules, exclusions, assumptions, and limitations."
        canonical="https://iamieshiadanielle.com/burnout-quiz-methodology"
        schemaJson={[
          {
            "@type": "WebPage",
            "@id":
              "https://iamieshiadanielle.com/burnout-quiz-methodology#webpage",
            url: "https://iamieshiadanielle.com/burnout-quiz-methodology",
            name: "Where Is Your Burnout Coming From? Design, Scoring, and Limitations of a Six-Domain Burnout Source Inventory",
            isPartOf: { "@id": "https://iamieshiadanielle.com/#website" },
            about: { "@id": "https://iamieshiadanielle.com/#person" },
            inLanguage: "en-US",
          },
          {
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://iamieshiadanielle.com",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Burnout Quiz Methodology",
                item: "https://iamieshiadanielle.com/burnout-quiz-methodology",
              },
            ],
          },
          {
            "@type": "Article",
            "@id":
              "https://iamieshiadanielle.com/burnout-quiz-methodology#article",
            headline:
              "Where Is Your Burnout Coming From? Design, Scoring, and Limitations of a Six-Domain Burnout Source Inventory",
            author: { "@id": "https://iamieshiadanielle.com/#person" },
            publisher: { "@id": "https://iamieshiadanielle.com/#organization" },
            datePublished: "2026-09-01",
            dateModified: "2026-09-01",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id":
                "https://iamieshiadanielle.com/burnout-quiz-methodology#webpage",
            },
            inLanguage: "en-US",
          },
        ]}
      />
      <div className="min-h-screen bg-[#FAF6F0] text-[#380C1E] flex flex-col font-sans">
        <Header />
        <main className="flex-1 py-16 md:py-24 px-4">
          <article className="max-w-3xl mx-auto bg-white/70 backdrop-blur-md border border-[#E8DEC8] p-8 md:p-12 rounded-3xl shadow-sm">
            <MethodologyIntro />
            <MethodologyBackground />
            <MethodologyConcept />
            <MethodologyArchitecture />
            <MethodologyScoring />
            <MethodologyExclusions />
            <MethodologyClosing />
          </article>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default BurnoutMethodology;
